(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hand-patch-customizer"] && !Shopify.designMode) return;
  try {
    
(function () {
  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function initCustomizer(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    document.body.classList.add('hand-customizer-page');

    var baseImage = root.querySelector('[data-base-image]');
    var zone = root.querySelector('[data-design-zone]');
    var variantButtons = Array.from(root.querySelectorAll('[data-variant-button]'));
    var swatchButtons = Array.from(root.querySelectorAll('[data-swatch-button]'));
    var patchButtons = Array.from(root.querySelectorAll('[data-patch-button]'));
    var patchSearch = root.querySelector('[data-patch-search]');
    var patchGrid = root.querySelector('[data-patch-grid]');
    var patchCategories = root.querySelector('[data-patch-categories]');
    var patchShowMore = root.querySelector('[data-patch-show-more]');
    var patchCarouselNav = root.querySelector('[data-patch-carousel-nav]');
    var patchPrev = root.querySelector('[data-patch-prev]');
    var patchNext = root.querySelector('[data-patch-next]');
    var patchResultCount = root.querySelector('[data-patch-result-count]');
    var patchEmpty = root.querySelector('[data-patch-empty]');
    var selectedPatchTray = root.querySelector('[data-selected-patch-tray]');
    var selectedPatchList = root.querySelector('[data-selected-patch-list]');
    var selectedPatchTotal = root.querySelector('[data-selected-patch-total]');
    var stage = root.querySelector('[data-stage]');
    var editPanel = root.querySelector('[data-edit-panel]');
    var selectedName = root.querySelector('[data-selected-name]');
    var selectedSize = root.querySelector('[data-selected-size]');
    var patchCount = root.querySelector('[data-patch-count]');
    var totalPrice = root.querySelector('[data-total-price]');
    var addButton = root.querySelector('[data-add-customized]');
    var status = root.querySelector('[data-status]');
    var currency = root.dataset.currency || 'MYR';
    var bagWidthCm = Number(root.dataset.bagWidthCm || 21);
    var bagHeightCm = Number(root.dataset.bagHeightCm || 22.5);
    var placementMarginCm = Number(root.dataset.placementMarginCm || 0);
    var doubleSided = root.dataset.doubleSided === 'true';
    var productBackImage = root.dataset.backImage || '';
    var surfaceButtons = Array.from(root.querySelectorAll('[data-surface-button]'));
    var surfaceCountNodes = Array.from(root.querySelectorAll('[data-surface-count]'));

    var state = {
      variantId: '',
      variantTitle: '',
      basePrice: 0,
      placements: [],
      selectedUid: null,
      counter: 0,
      patchQuery: '',
      patchCategory: 'All',
      patchVisibleLimit: 12,
      surface: 'front',
      frontImage: baseImage ? baseImage.src : '',
      currentBackImage: ''
    };

    var money = new Intl.NumberFormat('en-MY', {
      style: 'currency',
      currency: currency
    });

    function activeBackImage() {
      if (state.currentBackImage) return state.currentBackImage;
      if (variantButtons.length <= 1 && productBackImage) return productBackImage;
      return state.frontImage;
    }

        function surfaceZoneValue(surface, key) {
      var prefix = surface === 'back' ? 'back' : 'front';
      var datasetKey = prefix + 'Zone' + key.charAt(0).toUpperCase() + key.slice(1);
      return root.dataset[datasetKey] || '';
    }

    function renderSurface(surface) {
      state.surface = surface === 'back' && doubleSided ? 'back' : 'front';

      var left = surfaceZoneValue(state.surface, 'left');
      var top = surfaceZoneValue(state.surface, 'top');
      var width = surfaceZoneValue(state.surface, 'width');
      var height = surfaceZoneValue(state.surface, 'height');

      if (left) zone.style.left = left + '%';
      if (top) zone.style.top = top + '%';
      if (width) zone.style.width = width + '%';

      if (height) {
        zone.classList.add('has-photo-height');
        zone.style.height = height + '%';
        zone.style.aspectRatio = 'auto';
      } else {
        zone.classList.remove('has-photo-height');
        zone.style.removeProperty('height');
        zone.style.removeProperty('aspect-ratio');
      }

      if (baseImage) {
        baseImage.src = state.surface === 'back' ? activeBackImage() : state.frontImage;
      }

      state.placements.forEach(function (item) {
        item.el.hidden = item.surface !== state.surface;
      });

      surfaceButtons.forEach(function (button) {
        var active = button.dataset.surfaceButton === state.surface;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      state.selectedUid = null;
      updateSelectionUI();
    }

        function selectedPlacement() {
      return state.placements.find(function (item) {
        return item.uid === state.selectedUid;
      }) || null;
    }

    function normalizePatchText(value) {
      return String(value || '').toLowerCase().trim();
    }

    function patchMatches(button) {
      var query = normalizePatchText(state.patchQuery);
      var category = button.dataset.patchCategory || 'Other';
      var searchText = normalizePatchText(
        (button.dataset.patchName || '') + ' ' +
        (button.dataset.patchProductTitle || '') + ' ' +
        category
      );

      var matchesQuery = !query || searchText.indexOf(query) !== -1;
      var matchesCategory = state.patchCategory === 'All' || category === state.patchCategory;
      return matchesQuery && matchesCategory;
    }

    function patchPageSize() {
      if (window.matchMedia('(max-width: 900px)').matches) return 9;
      return 12;
    }

    function renderPatchLibrary(resetLimit) {
      if (resetLimit) state.patchVisibleLimit = 12;

      var matches = patchButtons.filter(patchMatches);
      var isAll = state.patchCategory === 'All';

      if (!patchGrid) return;

      patchGrid.classList.toggle('is-horizontal', isAll);
      patchGrid.innerHTML = '';

      patchButtons.forEach(function (button) {
        button.hidden = true;
      });

      if (isAll) {
        var pageSize = patchPageSize();
        for (var start = 0; start < matches.length; start += pageSize) {
          var page = document.createElement('div');
          page.className = 'hand-patch-customizer__patch-page';

          matches.slice(start, start + pageSize).forEach(function (button) {
            button.hidden = false;
            page.appendChild(button);
          });

          patchGrid.appendChild(page);
        }

        if (patchResultCount) {
          var pageCount = matches.length ? Math.ceil(matches.length / pageSize) : 0;
          patchResultCount.textContent = matches.length
            ? matches.length + ' patches' + (pageCount > 1 ? ' · ' + pageCount + ' pages' : '')
            : '';
        }

        if (patchCarouselNav) {
          patchCarouselNav.hidden = matches.length <= pageSize;
        }
        if (patchShowMore) patchShowMore.hidden = true;

        if (resetLimit) patchGrid.scrollLeft = 0;
      } else {
        patchButtons.forEach(function (button) {
          patchGrid.appendChild(button);
        });

        var visibleMatches = matches.slice(0, state.patchVisibleLimit);
        visibleMatches.forEach(function (button) {
          button.hidden = false;
        });

        if (patchResultCount) {
          patchResultCount.textContent = matches.length
            ? 'Showing ' + Math.min(matches.length, state.patchVisibleLimit) + ' of ' + matches.length
            : '';
        }

        if (patchCarouselNav) patchCarouselNav.hidden = true;
        if (patchShowMore) {
          patchShowMore.hidden = matches.length <= state.patchVisibleLimit;
        }
      }

      if (patchEmpty) patchEmpty.hidden = matches.length !== 0;
    }

    function renderPatchCategories() {
      if (!patchCategories) return;

      var priority = ['Malaysia', 'Food', 'Slang', 'Flowers', 'Alphabet', 'Other'];
      var seen = {};
      patchButtons.forEach(function (button) {
        var category = button.dataset.patchCategory || 'Other';
        seen[category] = true;
      });

      var categories = Object.keys(seen).sort(function (a, b) {
        var ai = priority.indexOf(a);
        var bi = priority.indexOf(b);
        if (ai === -1 && bi === -1) return a.localeCompare(b);
        if (ai === -1) return 1;
        if (bi === -1) return -1;
        return ai - bi;
      });

      patchCategories.innerHTML = '';
      ['All'].concat(categories).forEach(function (category) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'hand-patch-customizer__category-button';
        button.textContent = category;
        button.classList.toggle('is-active', category === state.patchCategory);
        button.setAttribute('aria-pressed', category === state.patchCategory ? 'true' : 'false');
        button.addEventListener('click', function () {
          state.patchCategory = category;
          Array.from(patchCategories.querySelectorAll('button')).forEach(function (item) {
            var active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          renderPatchLibrary(true);
        });
        patchCategories.appendChild(button);
      });
    }

    function renderSelectedPatchTray() {
      if (!selectedPatchTray || !selectedPatchList || !selectedPatchTotal) return;

      selectedPatchTray.hidden = state.placements.length === 0;
      selectedPatchTotal.textContent = state.placements.length;
      selectedPatchList.innerHTML = '';

      state.placements.forEach(function (item) {
        var chip = document.createElement('div');
        chip.className = 'hand-patch-customizer__selected-chip';

        var selectButton = document.createElement('button');
        selectButton.type = 'button';
        selectButton.className = 'hand-patch-customizer__selected-chip-select';
        selectButton.setAttribute('aria-label', 'Select ' + item.name + ' on the preview');

        var img = document.createElement('img');
        img.src = item.image;
        img.alt = '';

        var label = document.createElement('span');
        label.textContent = item.name + (doubleSided ? ' · ' + (item.surface === 'back' ? 'Back' : 'Front') : '');

        selectButton.appendChild(img);
        selectButton.appendChild(label);
        selectButton.addEventListener('click', function () {
          if (item.surface !== state.surface) {
            renderSurface(item.surface);
          }
          selectPlacement(item);
          if (stage) stage.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });

        var removeButton = document.createElement('button');
        removeButton.type = 'button';
        removeButton.className = 'hand-patch-customizer__selected-chip-remove';
        removeButton.textContent = '×';
        removeButton.setAttribute('aria-label', 'Remove ' + item.name);
        removeButton.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          removePlacement(item);
        });

        chip.appendChild(selectButton);
        chip.appendChild(removeButton);
        selectedPatchList.appendChild(chip);
      });
    }

        function updateSummary() {
      var patchesTotal = state.placements.reduce(function (sum, item) {
        return sum + item.price;
      }, 0);
      totalPrice.textContent = money.format((state.basePrice + patchesTotal) / 100);
      patchCount.textContent = state.placements.length + ' selected';

      var frontCount = state.placements.filter(function (item) { return item.surface === 'front'; }).length;
      var backCount = state.placements.filter(function (item) { return item.surface === 'back'; }).length;
      surfaceCountNodes.forEach(function (node) {
        node.textContent = node.dataset.surfaceCount === 'back' ? backCount : frontCount;
      });

      renderSelectedPatchTray();
    }

    function updateSelectionUI() {
      var selected = selectedPlacement();
      state.placements.forEach(function (item) {
        item.el.classList.toggle('is-selected', selected && item.uid === selected.uid);
        item.el.setAttribute('aria-pressed', selected && item.uid === selected.uid ? 'true' : 'false');
      });
      if (selected) {
        editPanel.hidden = false;
        selectedName.textContent = selected.name;
        selectedSize.textContent = 'Actual size: ' + selected.widthCm + ' × ' + selected.heightCm + ' cm';
      } else {
        editPanel.hidden = true;
        selectedName.textContent = '';
        selectedSize.textContent = '';
      }
    }

    function applyPlacement(item) {
      item.widthPct = (item.widthCm / bagWidthCm) * 100;
      item.heightPct = (item.heightCm / bagHeightCm) * 100;
      var halfW = item.widthPct / 2;
      var halfH = item.heightPct / 2;
      var marginXPct = (placementMarginCm / bagWidthCm) * 100;
      var marginYPct = (placementMarginCm / bagHeightCm) * 100;
      var minX = halfW - marginXPct;
      var maxX = 100 - halfW + marginXPct;
      var minY = halfH - marginYPct;
      var maxY = 100 - halfH + marginYPct;

      if (minX > maxX) {
        item.x = 50;
      } else {
        item.x = clamp(item.x, minX, maxX);
      }

      if (minY > maxY) {
        item.y = 50;
      } else {
        item.y = clamp(item.y, minY, maxY);
      }
      item.el.style.left = item.x + '%';
      item.el.style.top = item.y + '%';
      item.el.style.width = item.widthPct + '%';
      item.el.style.height = item.heightPct + '%';
      item.el.style.transform = 'translate(-50%, -50%) rotate(' + item.rotation + 'deg)';
    }

    function selectPlacement(item) {
      state.selectedUid = item ? item.uid : null;
      updateSelectionUI();
    }

    function removePlacement(item) {
      if (!item) return;

      if (item.el) item.el.remove();
      state.placements = state.placements.filter(function (placement) {
        return placement.uid !== item.uid;
      });

      if (state.selectedUid === item.uid) {
        state.selectedUid = null;
      }

      updateSelectionUI();
      updateSummary();
    }

    function bringPlacementToFront(item) {
      if (!item) return;

      state.placements = state.placements.filter(function (placement) {
        return placement.uid !== item.uid;
      });
      state.placements.push(item);

      if (item.el && item.el.parentNode === zone) {
        zone.appendChild(item.el);
      }

      selectPlacement(item);
    }

    function addPatch(button) {
      var widthCm = Number(button.dataset.patchWidthCm || 4);
      var heightCm = Number(button.dataset.patchHeightCm || 4);
      var uid = 'patch-' + (++state.counter);
      var surfacePlacementCount = state.placements.filter(function (placement) {
        return placement.surface === state.surface;
      }).length;
      var item = {
        uid: uid,
        variantId: button.dataset.patchVariantId,
        name: button.dataset.patchName,
        price: Number(button.dataset.patchPrice || 0),
        image: button.dataset.patchImage,
        widthCm: widthCm,
        heightCm: heightCm,
        widthPct: 0,
        heightPct: 0,
        surface: state.surface,
        x: clamp(48 + (surfacePlacementCount % 4) * 4, 20, 80),
        y: clamp(48 + (surfacePlacementCount % 3) * 4, 20, 80),
        rotation: 0,
        el: null
      };

      var el = document.createElement('button');
      el.type = 'button';
      el.className = 'hand-patch-customizer__placed-patch';
      el.setAttribute('aria-label', 'Placed patch: ' + item.name);
      el.setAttribute('aria-pressed', 'false');

      var img = document.createElement('img');
      img.src = item.image;
      img.alt = '';
      el.appendChild(img);

      var rotateHandle = document.createElement('span');
      rotateHandle.className = 'hand-patch-customizer__rotate-handle';
      rotateHandle.dataset.rotateHandle = '';
      rotateHandle.textContent = '↻';
      rotateHandle.setAttribute('aria-hidden', 'true');
      rotateHandle.setAttribute('title', 'Rotate patch');
      el.appendChild(rotateHandle);

      var bringFrontHandle = document.createElement('span');
      bringFrontHandle.className = 'hand-patch-customizer__bring-front-handle';
      bringFrontHandle.dataset.bringFrontHandle = '';
      bringFrontHandle.textContent = '↑';
      bringFrontHandle.setAttribute('aria-hidden', 'true');
      bringFrontHandle.setAttribute('title', 'Bring patch to front');
      el.appendChild(bringFrontHandle);

      item.el = el;
      zone.appendChild(el);
      state.placements.push(item);
      applyPlacement(item);
      selectPlacement(item);
      updateSummary();

      el.addEventListener('click', function (event) {
        if (event.target.closest('[data-rotate-handle], [data-bring-front-handle]')) return;
        selectPlacement(item);
      });

      rotateHandle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        if (rotateHandle.dataset.dragged === 'true') {
          rotateHandle.dataset.dragged = 'false';
          return;
        }

        item.rotation = Math.round((item.rotation + 15) * 10) / 10;
        applyPlacement(item);
      });

      bringFrontHandle.addEventListener('pointerdown', function (event) {
        event.preventDefault();
        event.stopPropagation();
        selectPlacement(item);
      });

      bringFrontHandle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        bringPlacementToFront(item);
      });

      rotateHandle.addEventListener('pointerdown', function (event) {
        if (event.button !== undefined && event.button !== 0) return;

        event.preventDefault();
        event.stopPropagation();
        selectPlacement(item);
        rotateHandle.dataset.dragged = 'false';

        var rect = el.getBoundingClientRect();
        var centerX = rect.left + rect.width / 2;
        var centerY = rect.top + rect.height / 2;
        var startAngle = Math.atan2(event.clientY - centerY, event.clientX - centerX);
        var startRotation = item.rotation || 0;

        rotateHandle.setPointerCapture(event.pointerId);

        function rotate(moveEvent) {
          var currentAngle = Math.atan2(moveEvent.clientY - centerY, moveEvent.clientX - centerX);
          var delta = (currentAngle - startAngle) * 180 / Math.PI;

          if (Math.abs(delta) > 2) {
            rotateHandle.dataset.dragged = 'true';
          }

          item.rotation = Math.round((startRotation + delta) * 10) / 10;
          applyPlacement(item);
        }

        function stopRotate(endEvent) {
          if (rotateHandle.hasPointerCapture(endEvent.pointerId)) {
            rotateHandle.releasePointerCapture(endEvent.pointerId);
          }
          rotateHandle.removeEventListener('pointermove', rotate);
          rotateHandle.removeEventListener('pointerup', stopRotate);
          rotateHandle.removeEventListener('pointercancel', stopRotate);
        }

        rotateHandle.addEventListener('pointermove', rotate);
        rotateHandle.addEventListener('pointerup', stopRotate);
        rotateHandle.addEventListener('pointercancel', stopRotate);
      });

      el.addEventListener('pointerdown', function (event) {
        if (event.target.closest('[data-rotate-handle], [data-bring-front-handle]')) return;
        if (event.button !== undefined && event.button !== 0) return;
        selectPlacement(item);
        el.setPointerCapture(event.pointerId);

        function move(moveEvent) {
          var rect = zone.getBoundingClientRect();
          if (!rect.width || !rect.height) return;
          item.x = ((moveEvent.clientX - rect.left) / rect.width) * 100;
          item.y = ((moveEvent.clientY - rect.top) / rect.height) * 100;
          applyPlacement(item);
        }

        function end(endEvent) {
          if (el.hasPointerCapture(endEvent.pointerId)) {
            el.releasePointerCapture(endEvent.pointerId);
          }
          el.removeEventListener('pointermove', move);
          el.removeEventListener('pointerup', end);
          el.removeEventListener('pointercancel', end);
        }

        el.addEventListener('pointermove', move);
        el.addEventListener('pointerup', end);
        el.addEventListener('pointercancel', end);
      });
    }

    function getVariantOptions(button) {
      return [
        button ? (button.dataset.option1 || '') : '',
        button ? (button.dataset.option2 || '') : '',
        button ? (button.dataset.option3 || '') : ''
      ];
    }

    function syncSwatches(button) {
      if (!swatchButtons.length || !button) return;

      var selectedOptions = getVariantOptions(button);

      swatchButtons.forEach(function (swatch) {
        var index = Number(swatch.dataset.optionIndex || 1) - 1;
        var active = swatch.dataset.swatchValue === selectedOptions[index];
        swatch.classList.toggle('is-active', active);
        swatch.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      selectedOptions.forEach(function (value, index) {
        var label = root.querySelector('[data-swatch-label-index="' + (index + 1) + '"]');
        if (label && value) label.textContent = value;
      });
    }

    function chooseVariant(button) {
      if (!button) return;

      state.variantId = button.dataset.variantId;
      state.variantTitle = button.dataset.variantTitle;
      state.basePrice = Number(button.dataset.variantPrice || 0);

      if (button.dataset.variantImage) {
        state.frontImage = button.dataset.variantImage;
      }
      state.currentBackImage = button.dataset.variantBackImage || '';
      baseImage.src = state.surface === 'back' ? activeBackImage() : state.frontImage;

      variantButtons.forEach(function (item) {
        var active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      syncSwatches(button);
      updateSummary();
    }

    variantButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        chooseVariant(button);
      });
    });

    swatchButtons.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var current = variantButtons.find(function (button) {
          return button.dataset.variantId === state.variantId;
        }) || variantButtons[0];

        if (!current) return;

        var selectedOptions = getVariantOptions(current);
        var changedIndex = Number(swatch.dataset.optionIndex || 1) - 1;
        selectedOptions[changedIndex] = swatch.dataset.swatchValue;

        var match = variantButtons.find(function (button) {
          var options = getVariantOptions(button);
          return (
            options[0] === selectedOptions[0] &&
            options[1] === selectedOptions[1] &&
            options[2] === selectedOptions[2]
          );
        });

        if (!match) {
          match = variantButtons.find(function (button) {
            return getVariantOptions(button)[changedIndex] === swatch.dataset.swatchValue;
          });
        }

        if (match) chooseVariant(match);
      });
    });

    patchButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        addPatch(button);
      });
    });

    if (patchSearch) {
      patchSearch.addEventListener('input', function () {
        state.patchQuery = patchSearch.value || '';
        renderPatchLibrary(true);
      });
    }

    if (patchShowMore) {
      patchShowMore.addEventListener('click', function () {
        state.patchVisibleLimit += 12;
        renderPatchLibrary(false);
      });
    }

    function scrollPatchCarousel(direction) {
      if (!patchGrid) return;
      var amount = Math.max(280, patchGrid.clientWidth);
      patchGrid.scrollBy({
        left: direction * amount,
        behavior: 'smooth'
      });
    }

    if (patchPrev) {
      patchPrev.addEventListener('click', function () {
        scrollPatchCarousel(-1);
      });
    }

    if (patchNext) {
      patchNext.addEventListener('click', function () {
        scrollPatchCarousel(1);
      });
    }

    if (patchGrid) {
      patchGrid.addEventListener('wheel', function (event) {
        if (!patchGrid.classList.contains('is-horizontal')) return;
        if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;

        event.preventDefault();
        patchGrid.scrollLeft += event.deltaY;
      }, { passive: false });
    }

    renderPatchCategories();
    renderPatchLibrary(true);

    var patchResizeTimer = null;
    window.addEventListener('resize', function () {
      if (state.patchCategory !== 'All') return;
      window.clearTimeout(patchResizeTimer);
      patchResizeTimer = window.setTimeout(function () {
        renderPatchLibrary(true);
      }, 150);
    });

    surfaceButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        renderSurface(button.dataset.surfaceButton);
      });
    });

    root.querySelectorAll('[data-edit-action]').forEach(function (button) {
      button.addEventListener('click', function () {
        var item = selectedPlacement();
        if (!item) return;
        var action = button.dataset.editAction;

        if (action === 'left') item.x -= 3;
        if (action === 'right') item.x += 3;
        if (action === 'up') item.y -= 3;
        if (action === 'down') item.y += 3;
        if (action === 'rotate-left') item.rotation -= 15;
        if (action === 'rotate-right') item.rotation += 15;

        if (action === 'delete') {
          removePlacement(item);
          return;
        }

        applyPlacement(item);
      });
    });

    zone.addEventListener('click', function (event) {
      if (event.target === zone) selectPlacement(null);
    });

    if (stage) {
      stage.addEventListener('click', function (event) {
        if (event.target.closest('.hand-patch-customizer__placed-patch')) return;
        selectPlacement(null);
      });
    }

    function loadImageForCanvas(src) {
      return new Promise(function (resolve, reject) {
        if (!src) {
          reject(new Error('Missing preview image.'));
          return;
        }

        var img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = function () { resolve(img); };
        img.onerror = function () { reject(new Error('Could not load an image for the DIY preview.')); };
        img.src = src;
      });
    }

    function drawImageCover(ctx, img, x, y, width, height) {
      var imageRatio = img.naturalWidth / img.naturalHeight;
      var boxRatio = width / height;
      var sx = 0;
      var sy = 0;
      var sw = img.naturalWidth;
      var sh = img.naturalHeight;

      if (imageRatio > boxRatio) {
        sw = img.naturalHeight * boxRatio;
        sx = (img.naturalWidth - sw) / 2;
      } else if (imageRatio < boxRatio) {
        sh = img.naturalWidth / boxRatio;
        sy = (img.naturalHeight - sh) / 2;
      }

      ctx.drawImage(img, sx, sy, sw, sh, x, y, width, height);
    }

    function zoneRectForSurface(surface, stageWidth, stageHeight) {
      var leftPct = Number(surfaceZoneValue(surface, 'left') || 0);
      var topPct = Number(surfaceZoneValue(surface, 'top') || 0);
      var widthPct = Number(surfaceZoneValue(surface, 'width') || 100);
      var heightRaw = surfaceZoneValue(surface, 'height');
      var zoneWidth = stageWidth * (widthPct / 100);
      var zoneHeight;

      if (heightRaw !== '') {
        zoneHeight = stageHeight * (Number(heightRaw) / 100);
      } else {
        zoneHeight = zoneWidth * (bagHeightCm / bagWidthCm);
      }

      return {
        x: stageWidth * (leftPct / 100),
        y: stageHeight * (topPct / 100),
        width: zoneWidth,
        height: zoneHeight
      };
    }

    async function renderSurfaceToCanvas(surface) {
      var stageWidth = 800;
      var stageHeight = 1200;
      var canvas = document.createElement('canvas');
      canvas.width = stageWidth;
      canvas.height = stageHeight;
      var ctx = canvas.getContext('2d');

      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, stageWidth, stageHeight);

      var imageSrc = surface === 'back' ? activeBackImage() : state.frontImage;
      var base = await loadImageForCanvas(imageSrc);
      drawImageCover(ctx, base, 0, 0, stageWidth, stageHeight);

      var rect = zoneRectForSurface(surface, stageWidth, stageHeight);
      var placements = state.placements.filter(function (item) {
        return item.surface === surface;
      });

      for (var index = 0; index < placements.length; index += 1) {
        var item = placements[index];
        var patch = await loadImageForCanvas(item.image);
        var patchWidth = rect.width * ((item.widthCm / bagWidthCm));
        var patchHeight = rect.height * ((item.heightCm / bagHeightCm));
        var centerX = rect.x + rect.width * (item.x / 100);
        var centerY = rect.y + rect.height * (item.y / 100);

        ctx.save();
        ctx.translate(centerX, centerY);
        ctx.rotate((item.rotation || 0) * Math.PI / 180);
        ctx.drawImage(
          patch,
          -patchWidth / 2,
          -patchHeight / 2,
          patchWidth,
          patchHeight
        );
        ctx.restore();
      }

      return canvas;
    }

    function canvasToBlob(canvas, type, quality) {
      return new Promise(function (resolve, reject) {
        canvas.toBlob(function (blob) {
          if (blob) {
            resolve(blob);
          } else {
            reject(new Error('Could not generate the DIY preview image.'));
          }
        }, type || 'image/jpeg', quality || 0.92);
      });
    }

    async function buildDiyPreviewFile(customizerId) {
      var surfaces = doubleSided ? ['front', 'back'] : ['front'];
      var rendered = [];

      for (var s = 0; s < surfaces.length; s += 1) {
        rendered.push(await renderSurfaceToCanvas(surfaces[s]));
      }

      var stageWidth = 800;
      var stageHeight = 1200;
      var labelHeight = 72;
      var footerHeight = 58;
      var gap = 28;
      var outerPad = 28;
      var output = document.createElement('canvas');

      output.width =
        outerPad * 2 +
        rendered.length * stageWidth +
        Math.max(0, rendered.length - 1) * gap;
      output.height = outerPad * 2 + labelHeight + stageHeight + footerHeight;

      var ctx = output.getContext('2d');
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, output.width, output.height);

      ctx.fillStyle = '#111111';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.font = '600 28px Arial, sans-serif';

      rendered.forEach(function (surfaceCanvas, index) {
        var x = outerPad + index * (stageWidth + gap);
        var label = surfaces[index] === 'back' ? 'BACK' : 'FRONT';
        ctx.fillText(label, x + stageWidth / 2, outerPad + labelHeight / 2);
        ctx.drawImage(surfaceCanvas, x, outerPad + labelHeight, stageWidth, stageHeight);
      });

      ctx.font = '20px Arial, sans-serif';
      ctx.fillStyle = '#555555';
      ctx.fillText(
        'HAND Customizer ID: ' + customizerId,
        output.width / 2,
        outerPad + labelHeight + stageHeight + footerHeight / 2
      );

      var blob = await canvasToBlob(output, 'image/jpeg', 0.92);
      return new File(
        [blob],
        'HAND-DIY-' + customizerId + '.jpg',
        { type: 'image/jpeg' }
      );
    }

    addButton.addEventListener('click', async function () {
      if (!state.variantId) {
        status.textContent = 'Please choose a product option.';
        return;
      }

      addButton.disabled = true;
      status.textContent = 'Preparing your DIY preview…';

      var customizerId =
        'HAND-' +
        Date.now().toString(36).toUpperCase() +
        '-' +
        Math.random().toString(36).slice(2, 7).toUpperCase();

      var compactLayout = state.placements.map(function (item) {
        return [
          item.surface,
          item.variantId,
          Math.round(item.x * 10) / 10,
          Math.round(item.y * 10) / 10,
          item.widthCm,
          item.heightCm,
          item.rotation
        ];
      });

      var layoutString = JSON.stringify(compactLayout);
      var toteProperties = {
        'Selected option': state.variantTitle,
        'Patches': state.placements.length
          ? state.placements.map(function (item) { return item.name; }).join(', ')
          : 'No patches',
        'Front patches': state.placements.filter(function (item) { return item.surface === 'front'; }).map(function (item) { return item.name; }).join(', ') || 'No patches',
        'Back patches': state.placements.filter(function (item) { return item.surface === 'back'; }).map(function (item) { return item.name; }).join(', ') || 'No patches',
        '_HAND Customizer ID': customizerId,
        '_HAND Layout Version': '4',
        '_HAND Bag Size': bagWidthCm + 'x' + bagHeightCm + 'cm'
      };

      for (var i = 0, chunk = 1; i < layoutString.length; i += 240, chunk += 1) {
        toteProperties['_HAND Layout ' + chunk] = layoutString.slice(i, i + 240);
      }

      var grouped = {};
      state.placements.forEach(function (item) {
        var groupKey = item.variantId + '|' + item.surface;
        if (!grouped[groupKey]) {
          grouped[groupKey] = { variantId: item.variantId, surface: item.surface, quantity: 0 };
        }
        grouped[groupKey].quantity += 1;
      });

      var baseLineKey = '';

      try {
        var previewFile = await buildDiyPreviewFile(customizerId);
        status.textContent = 'Uploading your DIY preview…';

        var baseFormData = new FormData();
        baseFormData.append('id', String(state.variantId));
        baseFormData.append('quantity', '1');

        Object.keys(toteProperties).forEach(function (key) {
          baseFormData.append('properties[' + key + ']', String(toteProperties[key]));
        });

        baseFormData.append(
          'properties[_HAND DIY Preview]',
          previewFile,
          previewFile.name
        );

        var baseResponse = await fetch(root.dataset.cartAddUrl, {
          method: 'POST',
          headers: {
            'Accept': 'application/json'
          },
          body: baseFormData
        });

        var baseData = await baseResponse.json().catch(function () { return {}; });
        if (!baseResponse.ok) {
          throw new Error(
            baseData.description ||
            baseData.message ||
            'Could not upload the customised product preview.'
          );
        }

        baseLineKey =
          baseData.key ||
          (baseData.items && baseData.items[0] && baseData.items[0].key) ||
          '';

        var patchItems = [];
        Object.keys(grouped).forEach(function (groupKey) {
          var group = grouped[groupKey];
          patchItems.push({
            id: Number(group.variantId),
            quantity: group.quantity,
            properties: {
              '_HAND Customizer ID': customizerId,
              '_HAND Role': 'Patch add-on',
              '_HAND Surface': group.surface === 'back' ? 'Back' : 'Front'
            }
          });
        });

        if (patchItems.length) {
          status.textContent = 'Adding your selected patches…';

          var patchResponse = await fetch(root.dataset.cartAddUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ items: patchItems })
          });

          if (!patchResponse.ok) {
            var patchError = await patchResponse.json().catch(function () { return {}; });

            if (baseLineKey) {
              var changeUrl = root.dataset.cartAddUrl.replace(/add\.js$/, 'change.js');
              await fetch(changeUrl, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
                },
                body: JSON.stringify({ id: baseLineKey, quantity: 0 })
              }).catch(function () {});
            }

            throw new Error(
              patchError.description ||
              patchError.message ||
              'Could not add the selected patches.'
            );
          }
        }

        status.textContent = 'Added. Opening your cart…';
        window.location.assign(root.dataset.cartUrl);
      } catch (error) {
        status.textContent =
          error.message ||
          'Could not save the DIY preview. Please try again.';
        addButton.disabled = false;
      }
    });

    if (variantButtons.length) chooseVariant(variantButtons[0]);
    renderSurface('front');
    updateSummary();
  }

  function initAll(scope) {
    var base = scope || document;
    if (base.matches && base.matches('[data-hand-patch-customizer]')) initCustomizer(base);
    base.querySelectorAll('[data-hand-patch-customizer]').forEach(initCustomizer);
  }

  initAll(document);
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
